export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="bg-[#f0f4ee] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-8 h-8">
                <circle cx="16" cy="16" r="15" fill="#88B277" fillOpacity="0.15" stroke="#88B277" strokeWidth="1.5" />
                <path d="M16 8C13.5 8 11 10 11 13C11 16 13 17.5 16 20C19 17.5 21 16 21 13C21 10 18.5 8 16 8Z" fill="#88B277" />
                <path d="M10 22C10 22 12 20 16 20C20 20 22 22 22 22" stroke="#88B277" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              <span className="font-bold text-gray-800 text-lg">さくらデイサービス</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4 max-w-xs">
              地域の皆さまが安心して利用できるデイサービスを目指し、
              専門スタッフが誠実なケアを提供しています。
            </p>
            <p className="text-gray-400 text-xs">運営：社会福祉法人 さくら福祉会</p>
          </div>

          <div>
            <h4 className="font-bold text-gray-700 text-sm mb-4 uppercase tracking-wider">メニュー</h4>
            <ul className="space-y-3">
              {[
                { label: '特徴', href: '#features' },
                { label: 'サービス・料金', href: '#services' },
                { label: 'スタッフ紹介', href: '#staff' },
                { label: 'アクセス', href: '#access' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); handleScroll(item.href); }}
                    className="text-gray-500 text-sm hover:text-[#88B277] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-700 text-sm mb-4 uppercase tracking-wider">お問い合わせ</h4>
            <a href="tel:0120-000-000" className="text-[#88B277] font-bold text-xl block mb-1 cursor-pointer whitespace-nowrap">
              0120-000-000
            </a>
            <p className="text-gray-400 text-xs mb-4">平日 8:30〜17:30</p>
            <p className="text-gray-500 text-xs leading-relaxed">
              〒000-0000<br />
              東京都○○区○○町1-2-3<br />
              さくらビル1F
            </p>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs">
            &copy; 2024 社会福祉法人 さくら福祉会 All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-gray-400 text-xs hover:text-gray-600 transition-colors whitespace-nowrap">プライバシーポリシー</a>
            <a href="#" rel="nofollow" className="text-gray-400 text-xs hover:text-gray-600 transition-colors whitespace-nowrap">運営規程</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
